export default __webpack_public_path__ + "static/media/pool_icon_yellow.fd61f541.svg";